import { z } from 'zod';

const TagVariableSchema = z.object({
  category_friendly_name: z.string(),
  friendly_name: z.string(),
  group_path: z.string(),
  technical_name: z.string(),
  variable_id: z.string(),
});

const TagBestPracticeSchema = z.object({
  id: z.string(),
  title: z.string(),
  commonBestPracticeId: z.string(),
});

export const TagVariablesResponseSchema = z.object({
  bestPractices: z.array(TagBestPracticeSchema),
  variables: z.array(TagVariableSchema),
});
